var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "logo_svg__Symbol",
  x: 0,
  y: 0,
  viewBox: "0 0 309.6 73"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__st0{fill:#231464}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 69.6 2.2 67c2 1.7 4 2.7 6.6 2.7 2.3 0 3.7-1.1 3.7-2.6V67c0-1.5-.8-2.3-4.7-3.2-4.5-1.1-7-2.4-7-6.3v-.1c0-3.6 3-6.1 7.2-6.1 3.1 0 5.5.9 7.6 2.6l-2 2.8c-1.9-1.4-3.8-2.2-5.7-2.2-2.2 0-3.4 1.1-3.4 2.5v.1c0 1.6 1 2.3 5 3.3 4.4 1.1 6.7 2.7 6.7 6.2v.1c0 3.9-3.1 6.3-7.5 6.3-3.2 0-6.2-1.2-8.7-3.4M20.6 51.7h8.3c4.9 0 8 2.8 8 7v.1c0 4.7-3.8 7.2-8.4 7.2h-4.2v6.8h-3.7zm8 10.9c2.8 0 4.5-1.6 4.5-3.7v-.1c0-2.5-1.8-3.8-4.5-3.8h-4.3v7.6zM46.1 51.5h3.4l9.2 21.1h-3.9l-2.1-5.1h-9.9l-2.2 5.1h-3.8zm5.3 12.8-3.6-8.4-3.6 8.4zM62.1 51.7h9.4c2.6 0 4.7.8 6.1 2.1 1.1 1.1 1.7 2.7 1.7 4.5v.1c0 3.5-2.1 5.5-5 6.4l5.7 7.9h-4.4l-5.2-7.3h-4.6v7.3h-3.7zm9.1 10.4c2.6 0 4.3-1.4 4.3-3.5v-.1c0-2.2-1.6-3.5-4.3-3.5h-5.4v7h5.4zM83.9 51.7h15.6V55h-12v5.5H98v3.3H87.5v5.6h12v3.3H83.9zM104 51.7h9.4c2.4 0 4.3.7 5.5 1.9.9.9 1.4 2.1 1.4 3.5v.1c0 2.5-1.4 3.9-3 4.7 2.5.8 4.2 2.2 4.2 5.1v.1c0 3.8-3.1 5.8-7.8 5.8H104zm12.7 5.9c0-1.6-1.3-2.7-3.7-2.7h-5.3v5.6h5c2.4 0 4-.9 4-2.9m-3.2 6h-5.8v5.8h6.1c2.5 0 4-1 4-2.9v-.1c0-1.7-1.4-2.8-4.3-2.8M132.6 51.5h3.4l9.2 21.1h-3.9l-2.1-5.1h-9.9l-2.2 5.1h-3.8zm5.3 12.8-3.6-8.4-3.6 8.4zM148.7 51.7h3.4l11.2 14.5V51.7h3.6v21h-3.1l-11.6-14.9v14.9h-3.6v-21zM172.5 51.7h3.7v10.6l10-10.6h4.6l-8.8 9 9.1 12h-4.5l-7.2-9.4-3.3 3.4v6.1h-3.7V51.7zM194.3 51.7h15.6V55H198v5.5h10.5v3.3H198v5.6h12v3.3h-15.7zM214.5 51.7h3.4l11.2 14.5V51.7h3.6v21h-3.1L218 57.8v14.9h-3.6v-21zM245.8 69.6 248 67c2 1.7 4 2.7 6.6 2.7 2.3 0 3.7-1.1 3.7-2.6V67c0-1.5-.8-2.3-4.7-3.2-4.5-1.1-7-2.4-7-6.3v-.1c0-3.6 3-6.1 7.2-6.1 3.1 0 5.5.9 7.6 2.6l-2 2.8c-1.9-1.4-3.8-2.2-5.7-2.2-2.2 0-3.4 1.1-3.4 2.5v.1c0 1.6 1 2.3 5 3.3 4.4 1.1 6.7 2.7 6.7 6.2v.1c0 3.9-3.1 6.3-7.5 6.3-3.2 0-6.2-1.2-8.7-3.4M291.7 51.7h9.4c2.6 0 4.7.8 6.1 2.1 1.1 1.1 1.7 2.7 1.7 4.5v.1c0 3.5-2.1 5.5-5 6.4l5.7 7.9h-4.4l-5.2-7.3h-4.6v7.3h-3.7zm9.1 10.4c2.6 0 4.3-1.4 4.3-3.5v-.1c0-2.2-1.6-3.5-4.3-3.5h-5.4v7h5.4zM285.1 55.6l2-2-2.4-2.4-2 2c-1.8-1.2-4-2-6.5-2-6.5 0-11 4.9-11 10.9v.1c0 2.4.8 4.6 2.1 6.5l-2 2 2.4 2.4 2-2c1.8 1.2 4 2 6.5 2 6.5 0 11-5 11-10.9v-.1c0-2.4-.7-4.7-2.1-6.5m-16 6.6c0-4.1 2.9-7.5 7.1-7.5q2.25 0 3.9 1.2l-10.1 10c-.6-1.1-.9-2.4-.9-3.7m14.2 0c0 4.1-2.9 7.4-7.1 7.4q-2.25 0-3.9-1.2l10.1-10.1q.9 1.8.9 3.9",
  className: "logo_svg__st0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_1_",
  x1: -1.32,
  x2: -1.32,
  y1: 291.698,
  y2: 249.714,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m193.4 12.8 40.7 10.9c.3-.6.6-1.3.9-1.9l-44.5-12z",
  style: {
    fill: "url(#logo_svg__SVGID_1_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_2_",
  x1: 2.333,
  x2: 2.333,
  y1: 291.698,
  y2: 249.714,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m200.5 19.9 31.2 8.4s0-.1.1-.1l1.2-2.1-35.9-9.6z",
  style: {
    fill: "url(#logo_svg__SVGID_2_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_3_",
  x1: 6.032,
  x2: 6.032,
  y1: 291.698,
  y2: 249.713,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m207.6 27 21.3 5.7c.6-.8 1.1-1.6 1.6-2.5L203.6 23z",
  style: {
    fill: "url(#logo_svg__SVGID_3_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_4_",
  x1: 9.782,
  x2: 9.782,
  y1: 291.698,
  y2: 249.714,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m214.7 34.1 10.9 2.9c.7-.9 1.5-1.8 2.2-2.7l-17.6-4.7z",
  style: {
    fill: "url(#logo_svg__SVGID_4_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_5_",
  x1: 13.584,
  x2: 13.584,
  y1: 291.701,
  y2: 249.713,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M221.8 41.1c1-1 1.9-1.9 2.8-3l-7.8-2.1z",
  style: {
    fill: "url(#logo_svg__SVGID_5_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_6_",
  x1: -9.789,
  x2: -9.789,
  y1: 291.699,
  y2: 249.714,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m237.7 14.2.3-1.2-48.4-13-.7 1.2z",
  style: {
    fill: "url(#logo_svg__SVGID_6_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__SVGID_7_",
  x1: -4.927,
  x2: -4.927,
  y1: 291.698,
  y2: 249.714,
  gradientTransform: "rotate(120 178.648 204.544)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#783cbe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#e14706"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f5aa00"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M236.1 19c.2-.5.4-1 .6-1.6L187.2 4.2l-.9 1.5z",
  style: {
    fill: "url(#logo_svg__SVGID_7_)"
  }
}));
export default SvgLogo;